/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-number/webhook-form-number.component.scss */
.ant-input-clear-icon {
  margin-right: 6px;
  cursor: pointer;
  pointer-events: all;
}
/*# sourceMappingURL=webhook-form-number.component.css.map */
